module.exports = __webpack_public_path__ + "assets/three-dots-c56096.svg";